// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regional Offices Page Styles */

/* Loading */
.offices-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.offices-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-orange);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Table */
.offices-table-container {
  background: var(--bg-secondary);
  border-radius: 16px;
  border: 1px solid var(--border-color);
  overflow-x: auto;
}

.offices-table {
  width: 100%;
  border-collapse: collapse;
}

.offices-table th {
  text-align: left;
  padding: 16px 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

.offices-table td {
  padding: 16px 20px;
  font-size: 14px;
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
  white-space: nowrap;
}

.offices-table tr:last-child td {
  border-bottom: none;
}

.offices-table tr:hover td {
  background: var(--bg-tertiary);
}

/* Office Cell */
.offices-office-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.offices-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.offices-icon svg {
  width: 20px;
  height: 20px;
}

.offices-icon.hub {
  background: linear-gradient(135deg, #8E3A9A 0%, #6B2D85 100%);
}

.offices-office-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.offices-office-name {
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.offices-hub-badge {
  display: inline-block;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #8E3A9A 0%, #6B2D85 100%);
  color: #fff;
  border-radius: 4px;
}

.offices-office-meta {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Countries chips */
.offices-countries {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.offices-country-chip {
  display: inline-block;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(255, 107, 74, 0.15);
  color: #d35400;
  border-radius: 4px;
}

.offices-country-more {
  font-size: 12px;
  color: var(--text-secondary);
}

.offices-countries-fallback {
  font-size: 12px;
  color: var(--text-tertiary);
  font-style: italic;
}

.offices-countries-none {
  font-size: 12px;
  color: var(--text-tertiary);
}

/* Manager */
.offices-manager {
  font-size: 14px;
  color: var(--text-primary);
}

.offices-no-manager {
  font-size: 13px;
  color: var(--text-tertiary);
  font-style: italic;
}

/* User count */
.offices-user-count {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

/* Status badge */
.offices-status-badge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  text-transform: capitalize;
}

.offices-status-badge.active {
  background: rgba(46, 204, 113, 0.15);
  color: #27ae60;
}

.offices-status-badge.inactive {
  background: rgba(108, 117, 125, 0.15);
  color: #6c757d;
}

/* Actions */
.offices-actions {
  display: flex;
  gap: 8px;
}

.offices-action-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-tertiary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.offices-action-btn svg {
  width: 16px;
  height: 16px;
  stroke: var(--text-secondary);
}

.offices-action-btn:hover {
  background: var(--border-color);
}

.offices-action-btn:hover svg {
  stroke: var(--text-primary);
}

.offices-action-deactivate:hover {
  background: rgba(231, 76, 60, 0.1);
}

.offices-action-deactivate:hover svg {
  stroke: var(--danger);
}

/* Empty State */
.offices-empty {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

/* Modal */
.offices-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.offices-modal {
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  background: var(--bg-secondary);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

.offices-modal-countries {
  max-width: 600px;
}

/* Research pricing modal — wide enough for 4×10 grid */
.offices-modal-pricing {
  max-width: 1100px;
  width: 95vw;
}

.research-pricing-grid {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.research-pricing-grid th,
.research-pricing-grid td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--border-color);
  text-align: center;
}

.research-pricing-grid thead th {
  position: sticky;
  top: 0;
  background: var(--bg-tertiary, #f7f7f9);
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.research-pricing-grid thead th:first-child {
  text-align: left;
  min-width: 170px;
}

.research-pricing-grid tbody th {
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
  background: var(--bg-tertiary, #fafafa);
}

.research-pricing-grid tbody td {
  padding: 4px;
}

.research-pricing-grid tbody td input {
  width: 100%;
  min-width: 70px;
  padding: 7px 9px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  text-align: right;
  font-family: inherit;
  font-size: 13px;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, inherit);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.research-pricing-grid tbody td input:focus {
  outline: none;
  border-color: #FF6B4A;
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);
}

.research-pricing-grid tbody td input::placeholder {
  color: var(--text-secondary, #c4c0cc);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.offices-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.offices-modal-header h2 {
  font-size: 18px;
  font-weight: 600;
}

.offices-modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.offices-modal-close:hover {
  background: var(--bg-tertiary);
}

.offices-modal > form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.offices-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.offices-modal-error {
  padding: 12px 16px;
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.2);
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  margin-bottom: 20px;
}

.offices-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  flex-shrink: 0;
}

/* Form Fields */
.offices-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.offices-form-field {
  margin-bottom: 20px;
}

.offices-form-field:last-child {
  margin-bottom: 0;
}

.offices-form-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.offices-form-field input,
.offices-form-field select {
  width: 100%;
  padding: 12px 14px;
  font-size: 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.offices-form-field input:focus,
.offices-form-field select:focus {
  border-color: var(--accent-orange);
}

.offices-form-field input:disabled {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: not-allowed;
}

/* Info Box */
.offices-info-box {
  padding: 16px;
  background: var(--bg-primary);
  border-radius: 10px;
  margin-top: 20px;
}

.offices-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
}

.offices-info-row:first-child {
  padding-top: 0;
}

.offices-info-row:last-child {
  padding-bottom: 0;
}

.offices-info-row span {
  color: var(--text-secondary);
}

.offices-info-row strong {
  color: var(--text-primary);
}

/* Buttons */
.offices-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.offices-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.offices-btn-primary {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  color: #fff;
}

.offices-btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px -8px rgba(255, 107, 74, 0.5);
}

.offices-btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.offices-btn-secondary:hover:not(:disabled) {
  background: var(--border-color);
}

/* Countries Picker */
.offices-countries-picker {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
}

.offices-selected-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  min-height: 38px;
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

.offices-chips-empty {
  color: var(--text-tertiary);
  font-size: 13px;
  font-style: italic;
}

.offices-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 4px 10px;
  background: rgba(255, 107, 74, 0.15);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #d35400;
}

.offices-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: rgba(0, 0, 0, 0.08);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
}

.offices-chip-remove:hover {
  background: rgba(231, 76, 60, 0.25);
}

.offices-chip-remove svg {
  width: 10px;
  height: 10px;
  stroke: #c0392b;
  stroke-width: 2;
}

.offices-chips-more {
  padding: 4px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
}

/* Countries search */
.offices-countries-search {
  position: relative;
  padding: 10px 12px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.offices-countries-search svg {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  stroke: var(--text-tertiary);
  pointer-events: none;
}

.offices-countries-search input {
  width: 100%;
  padding: 8px 12px 8px 36px;
  font-size: 13px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  outline: none;
  box-sizing: border-box;
}

.offices-countries-search input:focus {
  border-color: var(--accent-orange);
}

/* Countries count */
.offices-countries-count {
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  background: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
}

.offices-countries-count strong {
  color: var(--accent-orange);
}

/* Countries list */
.offices-countries-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 4px;
}

.offices-country-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.1s ease;
}

.offices-country-item:hover {
  background: var(--bg-tertiary);
}

.offices-country-item.selected {
  background: rgba(255, 107, 74, 0.08);
}

.offices-checkbox {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.offices-country-item:hover .offices-checkbox {
  border-color: #999;
}

.offices-country-item.selected .offices-checkbox {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);
  border-color: transparent;
}

.offices-checkbox svg {
  width: 10px;
  height: 10px;
  stroke: #fff;
  stroke-width: 3;
  opacity: 0;
}

.offices-country-item.selected .offices-checkbox svg {
  opacity: 1;
}

.offices-country-code {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  min-width: 24px;
}

.offices-country-name {
  flex: 1 1;
  font-size: 14px;
  color: var(--text-primary);
}

.offices-countries-empty {
  padding: 20px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 13px;
}

/* Responsive */
@media (max-width: 768px) {
  .offices-form-row {
    grid-template-columns: 1fr;
  }

  .offices-table-container {
    overflow-x: auto;
  }

  .offices-table {
    min-width: 700px;
  }
}


/* ============================================
   Office staff — an office is run by a team, so the card lists everyone
   rather than showing a single name.
   ============================================ */
.offices-staff-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.offices-staff-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 10px;
  font-size: 13px;
}

.offices-staff-item + .offices-staff-item {
  border-top: 1px solid #f1f3f5;
}

.offices-staff-role {
  color: #6c757d;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.offices-staff-empty {
  padding: 16px;
  text-align: center;
  color: #999;
  font-size: 12px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/regional-offices.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,uCAAuC;EACvC,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mCAAmC;EACnC,mCAAmC;EACnC,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA;;;iDAGiD;AACjD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* Regional Offices Page Styles */\n\n/* Loading */\n.offices-loading {\n  display: flex;\n  justify-content: center;\n  padding: 80px 0;\n}\n\n.offices-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-orange);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Table */\n.offices-table-container {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  border: 1px solid var(--border-color);\n  overflow-x: auto;\n}\n\n.offices-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.offices-table th {\n  text-align: left;\n  padding: 16px 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.offices-table td {\n  padding: 16px 20px;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.offices-table tr:last-child td {\n  border-bottom: none;\n}\n\n.offices-table tr:hover td {\n  background: var(--bg-tertiary);\n}\n\n/* Office Cell */\n.offices-office-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.offices-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.offices-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.offices-icon.hub {\n  background: linear-gradient(135deg, #8E3A9A 0%, #6B2D85 100%);\n}\n\n.offices-office-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.offices-office-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.offices-hub-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background: linear-gradient(135deg, #8E3A9A 0%, #6B2D85 100%);\n  color: #fff;\n  border-radius: 4px;\n}\n\n.offices-office-meta {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Countries chips */\n.offices-countries {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.offices-country-chip {\n  display: inline-block;\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(255, 107, 74, 0.15);\n  color: #d35400;\n  border-radius: 4px;\n}\n\n.offices-country-more {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.offices-countries-fallback {\n  font-size: 12px;\n  color: var(--text-tertiary);\n  font-style: italic;\n}\n\n.offices-countries-none {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n/* Manager */\n.offices-manager {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.offices-no-manager {\n  font-size: 13px;\n  color: var(--text-tertiary);\n  font-style: italic;\n}\n\n/* User count */\n.offices-user-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Status badge */\n.offices-status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  text-transform: capitalize;\n}\n\n.offices-status-badge.active {\n  background: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n}\n\n.offices-status-badge.inactive {\n  background: rgba(108, 117, 125, 0.15);\n  color: #6c757d;\n}\n\n/* Actions */\n.offices-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.offices-action-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-tertiary);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.offices-action-btn svg {\n  width: 16px;\n  height: 16px;\n  stroke: var(--text-secondary);\n}\n\n.offices-action-btn:hover {\n  background: var(--border-color);\n}\n\n.offices-action-btn:hover svg {\n  stroke: var(--text-primary);\n}\n\n.offices-action-deactivate:hover {\n  background: rgba(231, 76, 60, 0.1);\n}\n\n.offices-action-deactivate:hover svg {\n  stroke: var(--danger);\n}\n\n/* Empty State */\n.offices-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n}\n\n/* Modal */\n.offices-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.offices-modal {\n  width: 100%;\n  max-width: 520px;\n  max-height: 90vh;\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n.offices-modal-countries {\n  max-width: 600px;\n}\n\n/* Research pricing modal — wide enough for 4×10 grid */\n.offices-modal-pricing {\n  max-width: 1100px;\n  width: 95vw;\n}\n\n.research-pricing-grid {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.research-pricing-grid th,\n.research-pricing-grid td {\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border-color);\n  text-align: center;\n}\n\n.research-pricing-grid thead th {\n  position: sticky;\n  top: 0;\n  background: var(--bg-tertiary, #f7f7f9);\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.research-pricing-grid thead th:first-child {\n  text-align: left;\n  min-width: 170px;\n}\n\n.research-pricing-grid tbody th {\n  text-align: left;\n  font-weight: 600;\n  white-space: nowrap;\n  background: var(--bg-tertiary, #fafafa);\n}\n\n.research-pricing-grid tbody td {\n  padding: 4px;\n}\n\n.research-pricing-grid tbody td input {\n  width: 100%;\n  min-width: 70px;\n  padding: 7px 9px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  text-align: right;\n  font-family: inherit;\n  font-size: 13px;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, inherit);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.research-pricing-grid tbody td input:focus {\n  outline: none;\n  border-color: #FF6B4A;\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);\n}\n\n.research-pricing-grid tbody td input::placeholder {\n  color: var(--text-secondary, #c4c0cc);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.offices-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.offices-modal-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.offices-modal-close {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.offices-modal-close:hover {\n  background: var(--bg-tertiary);\n}\n\n.offices-modal > form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.offices-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.offices-modal-error {\n  padding: 12px 16px;\n  background: rgba(231, 76, 60, 0.1);\n  border: 1px solid rgba(231, 76, 60, 0.2);\n  border-radius: 8px;\n  color: #e74c3c;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.offices-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-tertiary);\n  flex-shrink: 0;\n}\n\n/* Form Fields */\n.offices-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.offices-form-field {\n  margin-bottom: 20px;\n}\n\n.offices-form-field:last-child {\n  margin-bottom: 0;\n}\n\n.offices-form-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.offices-form-field input,\n.offices-form-field select {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.offices-form-field input:focus,\n.offices-form-field select:focus {\n  border-color: var(--accent-orange);\n}\n\n.offices-form-field input:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n}\n\n/* Info Box */\n.offices-info-box {\n  padding: 16px;\n  background: var(--bg-primary);\n  border-radius: 10px;\n  margin-top: 20px;\n}\n\n.offices-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  font-size: 14px;\n}\n\n.offices-info-row:first-child {\n  padding-top: 0;\n}\n\n.offices-info-row:last-child {\n  padding-bottom: 0;\n}\n\n.offices-info-row span {\n  color: var(--text-secondary);\n}\n\n.offices-info-row strong {\n  color: var(--text-primary);\n}\n\n/* Buttons */\n.offices-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.offices-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.offices-btn-primary {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  color: #fff;\n}\n\n.offices-btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px -8px rgba(255, 107, 74, 0.5);\n}\n\n.offices-btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.offices-btn-secondary:hover:not(:disabled) {\n  background: var(--border-color);\n}\n\n/* Countries Picker */\n.offices-countries-picker {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.offices-selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 12px;\n  min-height: 38px;\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.offices-chips-empty {\n  color: var(--text-tertiary);\n  font-size: 13px;\n  font-style: italic;\n}\n\n.offices-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 4px 10px;\n  background: rgba(255, 107, 74, 0.15);\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #d35400;\n}\n\n.offices-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  background: rgba(0, 0, 0, 0.08);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 0;\n}\n\n.offices-chip-remove:hover {\n  background: rgba(231, 76, 60, 0.25);\n}\n\n.offices-chip-remove svg {\n  width: 10px;\n  height: 10px;\n  stroke: #c0392b;\n  stroke-width: 2;\n}\n\n.offices-chips-more {\n  padding: 4px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n/* Countries search */\n.offices-countries-search {\n  position: relative;\n  padding: 10px 12px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.offices-countries-search svg {\n  position: absolute;\n  left: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  stroke: var(--text-tertiary);\n  pointer-events: none;\n}\n\n.offices-countries-search input {\n  width: 100%;\n  padding: 8px 12px 8px 36px;\n  font-size: 13px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.offices-countries-search input:focus {\n  border-color: var(--accent-orange);\n}\n\n/* Countries count */\n.offices-countries-count {\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  background: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.offices-countries-count strong {\n  color: var(--accent-orange);\n}\n\n/* Countries list */\n.offices-countries-list {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.offices-country-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: background 0.1s ease;\n}\n\n.offices-country-item:hover {\n  background: var(--bg-tertiary);\n}\n\n.offices-country-item.selected {\n  background: rgba(255, 107, 74, 0.08);\n}\n\n.offices-checkbox {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  border: 2px solid #ccc;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.offices-country-item:hover .offices-checkbox {\n  border-color: #999;\n}\n\n.offices-country-item.selected .offices-checkbox {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 100%);\n  border-color: transparent;\n}\n\n.offices-checkbox svg {\n  width: 10px;\n  height: 10px;\n  stroke: #fff;\n  stroke-width: 3;\n  opacity: 0;\n}\n\n.offices-country-item.selected .offices-checkbox svg {\n  opacity: 1;\n}\n\n.offices-country-code {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  min-width: 24px;\n}\n\n.offices-country-name {\n  flex: 1;\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.offices-countries-empty {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-tertiary);\n  font-size: 13px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .offices-form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .offices-table-container {\n    overflow-x: auto;\n  }\n\n  .offices-table {\n    min-width: 700px;\n  }\n}\n\n\n/* ============================================\n   Office staff — an office is run by a team, so the card lists everyone\n   rather than showing a single name.\n   ============================================ */\n.offices-staff-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n}\n\n.offices-staff-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 7px 10px;\n  font-size: 13px;\n}\n\n.offices-staff-item + .offices-staff-item {\n  border-top: 1px solid #f1f3f5;\n}\n\n.offices-staff-role {\n  color: #6c757d;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.offices-staff-empty {\n  padding: 16px;\n  text-align: center;\n  color: #999;\n  font-size: 12px;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
